// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewDes-module-wrapper--ZryaO","commentText":"ReviewDes-module-commentText--yjsAW"};